"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountriesClient = void 0;
const State_1 = require("../model/State");
const iso_3166_1_1 = __importDefault(require("iso-3166-1"));
class CountriesClient {
    allCountries() {
        return iso_3166_1_1.default.all().map((country) => ({
            alpha3: country.alpha3,
            alpha2: country.alpha2,
            name: country.country,
            states: country.alpha3 == 'USA' ? State_1.USAStates : [],
        }));
    }
}
exports.CountriesClient = CountriesClient;
//# sourceMappingURL=CountriesClient.js.map